<template>

    <v-card :color="settings.surveyBoxColor">

        <v-card-text>

            <!-- EDIT MODE -->
            <div v-if="editMode" class="text-left">
                <text-editor
                    v-model="commentBoxLabelModel"
                    hint="Comment box label">

                    <div :class="getFontClasses(settings.surveyBoxColor)"
                         style="text-align: left; padding-bottom: 5px;">
                        {{ commentBoxLabel }}
                    </div>

                </text-editor>

                <v-textarea solo
                            ref="commentBox"
                            :rows="4"
                            auto-grow
                            :dark="isDarkColor(settings.surveyBoxColor)"
                            :light="!isDarkColor(settings.surveyBoxColor)"
                            :counter="1000"
                            v-model="commentModel"
                ></v-textarea>

                <text-editor
                    v-model="actionButtonTextModel"
                    hint="Confirm unsubscription button text">

                    <v-btn :color="settings.actionButtonColor" :dark="isDarkColor(settings.actionButtonColor)">
                        {{ buttonText }}
                    </v-btn>

                </text-editor>
            </div>

            <!-- RENDER MODE -->
            <div v-else class="text-left">

                <div :class="getFontClasses(settings.surveyBoxColor)" style="padding-bottom: 5px;">
                    {{ commentBoxLabel }}
                </div>

                <v-textarea solo
                            ref="commentBox"
                            :rows="4"
                            auto-grow
                            :dark="isDarkColor(settings.surveyBoxColor)"
                            :light="!isDarkColor(settings.surveyBoxColor)"
                            :counter="1000"
                            v-model="commentModel"
                ></v-textarea>

                <v-btn :loading="saving"
                       :color="settings.actionButtonColor"
                       @click="clicked"
                       :dark="isDarkColor(settings.actionButtonColor)">
                    {{ buttonText }}
                </v-btn>

            </div>
        </v-card-text>
    </v-card>
</template>

<script>

import TextEditor from "../TextEditor";
import axios from "axios";
import colorMixin from "../DynamicProflingQuestions/colorMixin";

export default {

    name: "UnsubscribeButton",

    mixins: [colorMixin],

    components: {
        TextEditor
    },

    props: {
        buttonText: {
            type: String,
            required: true,
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        settings: {
            type: Object,
            required: true,
        },
        commentBoxLabel: {
            type: String,
            required: true,
        },
        locale: {
            type: Object,
            required: true,
        },
        subPanelId: {
            type: Number,
            required: false,
            default: null,
        },
    },

    data() {
        return {
            saving: false,
            commentModel: '',
        }
    },

    computed: {

        actionButtonTextModel: {
            get() {
                return this.buttonText;
            },
            set(value) {
                this.$emit('change:subPanelTranslations', {confirm_unsubscribe_button_text: value});
            }
        },

        commentBoxLabelModel: {
            get() {
                return this.commentBoxLabel;
            },
            set(value) {
                this.$emit('change:subPanelTranslations', {comment_box_label: value});
            }
        },
    },

    methods: {
        clicked() {
            this.saving = true;

            axios.post(window.location.href, {comment: this.commentModel})

                .then(({data}) => {
                    this.$emit('change:translations', {content: data.content});
                    this.$emit('click');

                })
                .catch(error => {
                    Bus.$emit('flash-message', {
                        type: 'error',
                        message: 'Oops! That failed please try again later!'
                    });
                })
                .finally(() => {
                    this.sendToUrl('/landing-page/' + this.subPanelId + '/' + this.locale.code + '/unsubscribe-confirmed')
                })
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.commentBox.focus();
        });
    }
}
</script>
